import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { first } from 'rxjs/operators';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AuthenticationService, ConfirmEmailValidator } from '@app/_services';

@Component({
  selector: 'app-register',
  templateUrl: 'register.component.html',
  styleUrls: ['register.component.css'],
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  // checked = true;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private http: HttpClient
  ) {
    // redirect to home if already logged in
    if (this.authenticationService.currentUserValue) {
      this.router.navigate(['/']);
    }
  }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group(
      {
        firstName: [null, [Validators.required]],
        // lastName: [null, [Validators.required]],
        lastName: [null],
        email: [null, [Validators.required]],
        confirmemail: [null, [Validators.required]],
        agree: [null, [Validators.requiredTrue]],
        status: [true],
        ressetPassword: [true],
      },
      {
        validator: ConfirmEmailValidator('email', 'confirmemail'),
      }
    );

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    for (const i in this.registerForm.controls) {
      this.registerForm.controls[i].markAsDirty();
      this.registerForm.controls[i].updateValueAndValidity();
    }

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    this.loading = true;
    this.authenticationService
      .register(this.registerForm.value)
      .pipe(first())
      .subscribe({
        next: () => {
          localStorage.setItem('accountCreated', '1');

          this.router.navigate(['../login'], { relativeTo: this.route });
        },
        error: (error) => {
          console.log(error, this.registerForm.value);
          this.loading = false;
        },
      });
  }

  public goTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }
}
